import { Injectable, ɵɵdefineInjectable, InjectionToken, Inject, ɵɵinject, Component, NgModule } from '@angular/core';
import { Subject, throwError } from 'rxjs';
import { __values } from 'tslib';
import { HttpParams, HttpHeaders, HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { catchError, map, finalize, takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { ActivationStart, Router } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/dialog.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DialogService = /** @class */ (function () {
    function DialogService() {
    }
    /**
     * @param {?} mensaje
     * @param {?=} tittle
     * @return {?}
     */
    DialogService.prototype.ShowDialog = /**
     * @param {?} mensaje
     * @param {?=} tittle
     * @return {?}
     */
    function (mensaje, tittle) {
        if (tittle === void 0) { tittle = "Error"; }
        mensaje = (mensaje == null) ? "" : mensaje;
        metroDialog.create({
            title: tittle,
            content: "<div style=\"min-width:300px;max-width: 600px;width:auto;\">" + mensaje + "</div>",
            actions: [
                {
                    title: "Ok",
                    onclick: (/**
                     * @param {?} el
                     * @return {?}
                     */
                    function (el) {
                        $(el).data("dialog").close();
                    })
                }
            ],
            options: {
                overlay: true,
                overlayColor: "op-dark",
                overlayClickClose: true,
            }
        });
    };
    /**
     * @param {?} mensaje
     * @param {?=} tittle
     * @return {?}
     */
    DialogService.prototype.ShowConfirm = /**
     * @param {?} mensaje
     * @param {?=} tittle
     * @return {?}
     */
    function (mensaje, tittle) {
        if (tittle === void 0) { tittle = ""; }
        /** @type {?} */
        var subject = new Subject();
        //let promesa = new Promise();
        metroDialog.create({
            title: tittle,
            content: "<div style=\"min-width:300px;max-width: 600px;width:auto;\"><strong>" + mensaje + "<strong></div>",
            actions: [
                {
                    title: "Ok",
                    onclick: (/**
                     * @param {?} el
                     * @return {?}
                     */
                    function (el) {
                        $(el).data("dialog").close();
                        // observable.
                        subject.next(true);
                    })
                },
                {
                    title: "Cancel",
                    onclick: (/**
                     * @param {?} el
                     * @return {?}
                     */
                    function (el) {
                        $(el).data("dialog").close();
                        subject.next(false);
                    })
                }
            ],
            options: {
                overlay: true,
                overlayColor: "op-dark",
                overlayClickClose: false
            }
        });
        return subject;
    };
    /**
     * @param {?} mensaje
     * @param {?=} tittle
     * @return {?}
     */
    DialogService.prototype.ShowConfirmYesNo = /**
     * @param {?} mensaje
     * @param {?=} tittle
     * @return {?}
     */
    function (mensaje, tittle) {
        if (tittle === void 0) { tittle = ""; }
        /** @type {?} */
        var subject = new Subject();
        metroDialog.create({
            title: tittle.toLocaleUpperCase(),
            content: "<div style=\"min-width:300px;max-width: 600px;width:auto;\"><strong>" + mensaje + "</strong></div>",
            actions: [
                {
                    title: "Si",
                    onclick: (/**
                     * @param {?} el
                     * @return {?}
                     */
                    function (el) {
                        $(el).data("dialog").close();
                        // observable.
                        subject.next(true);
                    })
                },
                {
                    title: "No",
                    onclick: (/**
                     * @param {?} el
                     * @return {?}
                     */
                    function (el) {
                        $(el).data("dialog").close();
                        subject.next(false);
                    })
                }
            ],
            options: {
                overlay: true,
                overlayColor: "op-dark",
                overlayClickClose: false
            }
        });
        return subject;
    };
    /**
     * @return {?}
     */
    DialogService.prototype.Snniper = /**
     * @return {?}
     */
    function () {
        if (this.idSnipper === void 0) {
            /** @type {?} */
            var dialog = metroDialog.create({
                //  title: "",
                content: "<div data-role='preloader' data-type='cycle' data-style='color'></div>"
                //  actions: [],
                //  options: {}
            });
            this.idSnipper = $(dialog["0"]).attr("id");
        }
        else {
            metroDialog.open("#" + this.idSnipper);
        }
    };
    /**
     * @return {?}
     */
    DialogService.prototype.SnniperClose = /**
     * @return {?}
     */
    function () {
        if (this.idSnipper != undefined) {
            metroDialog.close("#" + this.idSnipper);
            this.idSnipper = undefined;
        }
    };
    // Notificacion(mensaje:string) {
    //     $.Notify({
    //         // caption: 'Notify title',
    //         content: mensaje,
    //         // type: typeNotificion,
    //         keepOpen: true
    //     });
    // }
    // Notificacion(mensaje:string) {
    //     $.Notify({
    //         // caption: 'Notify title',
    //         content: mensaje,
    //         // type: typeNotificion,
    //         keepOpen: true
    //     });
    // }
    /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    DialogService.prototype.NotificacionSucess = 
    // Notificacion(mensaje:string) {
    //     $.Notify({
    //         // caption: 'Notify title',
    //         content: mensaje,
    //         // type: typeNotificion,
    //         keepOpen: true
    //     });
    // }
    /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    function (mensaje, keepOpen) {
        if (keepOpen === void 0) { keepOpen = false; }
        $.Notify({
            // caption: 'Notify title',
            content: mensaje,
            type: "success",
            keepOpen: keepOpen,
            timeout: 30000
        });
    };
    /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    DialogService.prototype.NotificacionAlert = /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    function (mensaje, keepOpen) {
        if (keepOpen === void 0) { keepOpen = false; }
        $.Notify({
            // caption: 'Notify title',
            content: mensaje,
            type: "alert",
            keepOpen: keepOpen,
            timeout: 30000
        });
    };
    /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    DialogService.prototype.NotificacionWarning = /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    function (mensaje, keepOpen) {
        if (keepOpen === void 0) { keepOpen = false; }
        $.Notify({
            // caption: 'Notify title',
            content: mensaje,
            type: "warning",
            keepOpen: keepOpen,
            timeout: 30000
        });
    };
    /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    DialogService.prototype.NotificacionInfo = /**
     * @param {?} mensaje
     * @param {?=} keepOpen
     * @return {?}
     */
    function (mensaje, keepOpen) {
        if (keepOpen === void 0) { keepOpen = false; }
        $.Notify({
            // caption: 'Notify title',
            content: mensaje,
            type: "info",
            keepOpen: keepOpen,
            timeout: 30000
        });
    };
    /**
     * @param {?} mensaje
     * @param {?} title
     * @param {?=} keepOpen
     * @return {?}
     */
    DialogService.prototype.NotificacionWarningTitle = /**
     * @param {?} mensaje
     * @param {?} title
     * @param {?=} keepOpen
     * @return {?}
     */
    function (mensaje, title, keepOpen) {
        if (keepOpen === void 0) { keepOpen = false; }
        $.Notify({
            caption: title,
            content: mensaje,
            type: "warning",
            keepOpen: keepOpen,
            timeout: 30000
        });
    };
    DialogService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ DialogService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DialogService_Factory() { return new DialogService(); }, token: DialogService, providedIn: "root" });
    return DialogService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DialogService.prototype.idSnipper;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/vesta.inject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var AUTHENTICATION = new InjectionToken('AUTHENTICATION_VESTA');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/call-http.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CallHttp = /** @class */ (function () {
    function CallHttp(http, autentication) {
        this.http = http;
        this.autentication = autentication;
    }
    /**
     * @template TResponse
     * @param {?} url
     * @param {?=} param
     * @param {?=} optionsT
     * @return {?}
     */
    CallHttp.prototype.httpGet = /**
     * @template TResponse
     * @param {?} url
     * @param {?=} param
     * @param {?=} optionsT
     * @return {?}
     */
    function (url, param, optionsT) {
        if (param === void 0) { param = null; }
        if (optionsT === void 0) { optionsT = null; }
        /** @type {?} */
        var urlGet = (param == null) ? url : url + "?" + param;
        /** @type {?} */
        var resp = null;
        /** @type {?} */
        var options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.get(urlGet, options) //: Observable<TResponse> =
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    };
    /**
     * @template TResponse
     * @param {?} url
     * @param {?} object
     * @param {?=} optionsT
     * @return {?}
     */
    CallHttp.prototype.httpGetParams = /**
     * @template TResponse
     * @param {?} url
     * @param {?} object
     * @param {?=} optionsT
     * @return {?}
     */
    function (url, object, optionsT) {
        if (optionsT === void 0) { optionsT = null; }
        /** @type {?} */
        var params = new HttpParams({ fromObject: object });
        /** @type {?} */
        var resp = null;
        /** @type {?} */
        var options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.get(url, { params: params, withCredentials: options.withCredentials }) //: Observable<TResponse> =
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    };
    /**
     * @param {?} url
     * @param {?=} param
     * @param {?=} optionsT
     * @return {?}
     */
    CallHttp.prototype.httpGetText = /**
     * @param {?} url
     * @param {?=} param
     * @param {?=} optionsT
     * @return {?}
     */
    function (url, param, optionsT) {
        if (param === void 0) { param = null; }
        if (optionsT === void 0) { optionsT = null; }
        /** @type {?} */
        var urlGet = (param == null) ? url : url + "?" + param;
        /** @type {?} */
        var resp = null;
        /** @type {?} */
        var options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.get(urlGet, { responseType: 'text', withCredentials: options.withCredentials })
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    };
    /**
     * @template TResponse
     * @param {?} url
     * @param {?=} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    CallHttp.prototype.httpPost = /**
     * @template TResponse
     * @param {?} url
     * @param {?=} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    function (url, contentBody, optionsT) {
        if (contentBody === void 0) { contentBody = {}; }
        if (optionsT === void 0) { optionsT = null; }
        /** @type {?} */
        var resp = null;
        /** @type {?} */
        var options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.post(url, contentBody, options)
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    };
    /**
     * @template TResponse
     * @param {?} url
     * @param {?} contentBody
     * @param {?=} options
     * @return {?}
     */
    CallHttp.prototype.httpPut = /**
     * @template TResponse
     * @param {?} url
     * @param {?} contentBody
     * @param {?=} options
     * @return {?}
     */
    function (url, contentBody, options) {
        if (options === void 0) { options = { withCredentials: true }; }
        /** @type {?} */
        var resp = null;
        /** @type {?} */
        var retorna = this.http.put(url, contentBody)
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    };
    /**
     * @template TResponse
     * @param {?} url
     * @param {?} contentBody
     * @param {?} contentType
     * @return {?}
     */
    CallHttp.prototype.httpPutFileShare = /**
     * @template TResponse
     * @param {?} url
     * @param {?} contentBody
     * @param {?} contentType
     * @return {?}
     */
    function (url, contentBody, contentType) {
        /** @type {?} */
        var resp = null;
        //Content-type
        /** @type {?} */
        var headers = new HttpHeaders({ 'Content-type': contentType });
        /** @type {?} */
        var retorna = this.http.put(url, contentBody, { headers: headers, withCredentials: false })
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    };
    /**
     * @param {?} url
     * @param {?} contentBody
     * @param {?} contentType
     * @return {?}
     */
    CallHttp.prototype.httpPutFileShareProgress = /**
     * @param {?} url
     * @param {?} contentBody
     * @param {?} contentType
     * @return {?}
     */
    function (url, contentBody, contentType) {
        /** @type {?} */
        var resp = null;
        //Content-type
        /** @type {?} */
        var headers = new HttpHeaders({ 'Content-type': contentType });
        /** @type {?} */
        var retorna = this.http.put(url, contentBody, { headers: headers, withCredentials: false, reportProgress: true, observe: 'events' })
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    };
    /**
     * @template TResponse
     * @param {?} url
     * @param {?} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    CallHttp.prototype.httpPostFormData = /**
     * @template TResponse
     * @param {?} url
     * @param {?} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    function (url, contentBody, optionsT) {
        if (optionsT === void 0) { optionsT = null; }
        /** @type {?} */
        var headers = new HttpHeaders({ 'enctype': 'multipart/form-data' });
        headers.append('Accept', 'application/json');
        /** @type {?} */
        var resp = null;
        /** @type {?} */
        var options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        //headers ?: Headers
        //const options = new RequestOptions({ headers: headers });
        /** @type {?} */
        var retorna = this.http.post(url, contentBody, { headers: headers, withCredentials: options.withCredentials })
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    };
    /**
     * @param {?} url
     * @param {?} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    CallHttp.prototype.httpPostText = /**
     * @param {?} url
     * @param {?} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    function (url, contentBody, optionsT) {
        if (optionsT === void 0) { optionsT = null; }
        /** @type {?} */
        var resp = null;
        /** @type {?} */
        var options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.post(url, contentBody, { responseType: 'text', withCredentials: options.withCredentials })
            .pipe(catchError(this.handleError("Error", resp)));
        return retorna;
    };
    /**
     * @param {?} url
     * @param {?} fileName
     * @param {?=} optionsT
     * @return {?}
     */
    CallHttp.prototype.httpGetFile = /**
     * @param {?} url
     * @param {?} fileName
     * @param {?=} optionsT
     * @return {?}
     */
    function (url, fileName, optionsT) {
        var _this = this;
        if (optionsT === void 0) { optionsT = null; }
        /** @type {?} */
        var resp = null;
        /** @type {?} */
        var options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.get(url, { responseType: 'blob', withCredentials: options.withCredentials })
            .pipe(catchError(this.handleError("Error", resp)), map((/**
         * @param {?} m
         * @return {?}
         */
        function (m) {
            _this.downloadFile(m, fileName);
        }))) //.map(m => );
        ;
        return retorna;
    };
    /**
     * @param {?} url
     * @param {?} fileName
     * @param {?=} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    CallHttp.prototype.httpPostFile = /**
     * @param {?} url
     * @param {?} fileName
     * @param {?=} contentBody
     * @param {?=} optionsT
     * @return {?}
     */
    function (url, fileName, contentBody, optionsT) {
        var _this = this;
        if (contentBody === void 0) { contentBody = {}; }
        if (optionsT === void 0) { optionsT = null; }
        /** @type {?} */
        var resp = null;
        /** @type {?} */
        var options = optionsT != null ? optionsT : { withCredentials: this.autentication.isAuthentication };
        /** @type {?} */
        var retorna = this.http.post(url, contentBody, { responseType: 'blob', withCredentials: options.withCredentials })
            .pipe(catchError(this.handleError("Error", resp)), map((/**
         * @param {?} m
         * @return {?}
         */
        function (m) {
            _this.downloadFile(m, fileName);
        }))) //.map(m => );
        ;
        return retorna;
    };
    /**
     * @private
     * @param {?} blob
     * @param {?} filename
     * @return {?}
     */
    CallHttp.prototype.downloadFile = /**
     * @private
     * @param {?} blob
     * @param {?} filename
     * @return {?}
     */
    function (blob, filename) {
        /** @type {?} */
        var a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
    };
    /**
     * @private
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    CallHttp.prototype.handleError = /**
     * @private
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            var e_1, _a;
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // log to console instead
            // TODO: better job of transforming error for user consumption
            //this.log(`${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            /** @type {?} */
            var msj = "";
            if (error.error) {
                if (error.error.Message == undefined && error.statusText != "Unknown Error" && (error.status == 404 || error.status == 412)) {
                    /** @type {?} */
                    var keysObject = Object.keys(error.error);
                    try {
                        for (var keysObject_1 = __values(keysObject), keysObject_1_1 = keysObject_1.next(); !keysObject_1_1.done; keysObject_1_1 = keysObject_1.next()) {
                            var k = keysObject_1_1.value;
                            msj += k + " - " + ((/** @type {?} */ (error.error[k]))).reduce((/**
                             * @param {?} r
                             * @param {?} n
                             * @param {?} i
                             * @return {?}
                             */
                            function (r, n, i) { return r + "<br />" + n; })) + "<br />";
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (keysObject_1_1 && !keysObject_1_1.done && (_a = keysObject_1.return)) _a.call(keysObject_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                else if (error.error.text) {
                    msj = error.error.text;
                }
                else {
                    msj = error.message;
                }
                if (error.error.Message != undefined)
                    msj = error.error.Message;
                if (msj == "")
                    msj = error.status + " - " + error.statusText;
                //msj = error.error.Message != undefined ? error.error.Message : (msj == "") ? error.message : msj;
            }
            else {
                msj = error.message;
            }
            return throwError(msj); //of(result as T);
        });
    };
    /**
     * @param {?} str
     * @return {?}
     */
    CallHttp.isJsonString = /**
     * @param {?} str
     * @return {?}
     */
    function (str) {
        try {
            str.json();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    CallHttp.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    CallHttp.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: [AUTHENTICATION,] }] }
    ]; };
    /** @nocollapse */ CallHttp.ngInjectableDef = ɵɵdefineInjectable({ factory: function CallHttp_Factory() { return new CallHttp(ɵɵinject(HttpClient), ɵɵinject(AUTHENTICATION)); }, token: CallHttp, providedIn: "root" });
    return CallHttp;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CallHttp.prototype.http;
    /**
     * @type {?}
     * @private
     */
    CallHttp.prototype.autentication;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/interceptor-spinner.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InterceptorSpinnerService = /** @class */ (function () {
    function InterceptorSpinnerService(dialogService) {
        this.dialogService = dialogService;
        this.Snniper = 0;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    InterceptorSpinnerService.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        var _this = this;
        this.RequestInterceptor();
        /** @type {?} */
        var handler = req.clone();
        return next.handle(handler).pipe(finalize((/**
         * @return {?}
         */
        function () { _this.ResponseInterceptor(); })));
    };
    /**
     * @private
     * @return {?}
     */
    InterceptorSpinnerService.prototype.RequestInterceptor = /**
     * @private
     * @return {?}
     */
    function () {
        this.Snniper += 1;
        if (this.Snniper == 1) {
            this.dialogService.Snniper();
        }
    };
    /**
     * @private
     * @return {?}
     */
    InterceptorSpinnerService.prototype.ResponseInterceptor = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.Snniper > 0) {
            this.Snniper -= 1;
        }
        if (this.Snniper == 0) {
            this.dialogService.SnniperClose();
        }
    };
    InterceptorSpinnerService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    InterceptorSpinnerService.ctorParameters = function () { return [
        { type: DialogService }
    ]; };
    /** @nocollapse */ InterceptorSpinnerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function InterceptorSpinnerService_Factory() { return new InterceptorSpinnerService(ɵɵinject(DialogService)); }, token: InterceptorSpinnerService, providedIn: "root" });
    return InterceptorSpinnerService;
}());
if (false) {
    /** @type {?} */
    InterceptorSpinnerService.prototype.Snniper;
    /**
     * @type {?}
     * @private
     */
    InterceptorSpinnerService.prototype.dialogService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/mapper.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Mapper = /** @class */ (function () {
    function Mapper() {
    }
    /**
     * @template T, TW
     * @param {?} inputObject
     * @param {?} outputObject
     * @return {?}
     */
    Mapper.Convert = /**
     * @template T, TW
     * @param {?} inputObject
     * @param {?} outputObject
     * @return {?}
     */
    function (inputObject, outputObject) {
        var e_1, _a;
        /** @type {?} */
        var keysObject = Object.keys(inputObject);
        try {
            for (var keysObject_1 = __values(keysObject), keysObject_1_1 = keysObject_1.next(); !keysObject_1_1.done; keysObject_1_1 = keysObject_1.next()) {
                var propiedad = keysObject_1_1.value;
                outputObject[propiedad] = inputObject[propiedad];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (keysObject_1_1 && !keysObject_1_1.done && (_a = keysObject_1.return)) _a.call(keysObject_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return outputObject;
    };
    /**
     * @template T, TW
     * @param {?} inputObjectList
     * @param {?} outputObject
     * @return {?}
     */
    Mapper.ConvertListObject = /**
     * @template T, TW
     * @param {?} inputObjectList
     * @param {?} outputObject
     * @return {?}
     */
    function (inputObjectList, outputObject) {
        var _this = this;
        /** @type {?} */
        var list = [];
        //var documento: TW;
        inputObjectList.Enumerable().forEach((/**
         * @param {?} f
         * @return {?}
         */
        function (f) {
            /** @type {?} */
            var a = ((/** @type {?} */ (Object))).create(outputObject);
            /** @type {?} */
            var objList = _this.Convert(f, a);
            list.push(objList);
        }));
        return list;
    };
    /**
     * @template T, TW
     * @param {?} inputObjectList
     * @param {?} outputObject
     * @return {?}
     */
    Mapper.ConvertListObject2 = /**
     * @template T, TW
     * @param {?} inputObjectList
     * @param {?} outputObject
     * @return {?}
     */
    function (inputObjectList, outputObject) {
        var _this = this;
        /** @type {?} */
        var list = [];
        //var documento: TW;
        inputObjectList.Enumerable().forEach((/**
         * @param {?} f
         * @return {?}
         */
        function (f) {
            /** @type {?} */
            var a = new outputObject();
            /** @type {?} */
            var objList = _this.Convert(f, a);
            list.push(objList);
        }));
        return list;
    };
    Mapper.decorators = [
        { type: Injectable }
    ];
    return Mapper;
}());
/**
 * @record
 */
function IObjectextended() { }
if (false) {
    /**
     * @template T
     * @param {?} o
     * @return {?}
     */
    IObjectextended.prototype.create = function (o) { };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/acceso-denegado/acceso-denegado.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccesoDenegadoComponent = /** @class */ (function () {
    function AccesoDenegadoComponent() {
    }
    /**
     * @return {?}
     */
    AccesoDenegadoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        $("body").css("background-color", "#D4DFE6");
        $(".Container").css("margin-top", "10%");
    };
    AccesoDenegadoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vesta-acceso-denegado',
                    template: "<div class=\"Container\">\r\n\r\n  <div class=\"MainGraphic\">\r\n    <svg class=\"Hummingbird\" viewBox=\"0 0 55 41\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M35.5 5L54.7.6H32.3L35.5 5zM12.4 40.8l10.3-10.1-6.2-6.7-4.1 16.8zM33.8 5.3L30.5.8l-5.4 4 8.7.5zM20.8 4.6L8.8 0l1.9 4.1 10.1.5zM0 5l15.2 15.4 7.5-14.2L0 5zM34.2 6.8l-9.9-.5-8 15.2 7.4 8.1 8-7.9 2.5-14.9z\" /></svg>\r\n\r\n    <svg class=\"Cog\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M29.18 19.07c-1.678-2.908-.668-6.634 2.256-8.328L28.29 5.295c-.897.527-1.942.83-3.057.83-3.36 0-6.085-2.743-6.085-6.126h-6.29c.01 1.043-.25 2.102-.81 3.07-1.68 2.907-5.41 3.896-8.34 2.21L.566 10.727c.905.515 1.69 1.268 2.246 2.234 1.677 2.904.673 6.624-2.24 8.32l3.145 5.447c.895-.522 1.935-.82 3.044-.82 3.35 0 6.066 2.725 6.083 6.092h6.29c-.004-1.035.258-2.08.81-3.04 1.676-2.902 5.4-3.893 8.325-2.218l3.145-5.447c-.9-.515-1.678-1.266-2.232-2.226zM16 22.48c-3.578 0-6.48-2.902-6.48-6.48S12.423 9.52 16 9.52c3.578 0 6.48 2.902 6.48 6.48s-2.902 6.48-6.48 6.48z\" /></svg>\r\n\r\n  </div>\r\n\r\n  <svg class=\"Spanner\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\r\n    <path d=\"M20.285 7.12c-.05-.17-.184-.3-.354-.345-.17-.047-.35.003-.476.126L16.838 9.46l-1.914-.383-.38-1.907 2.644-2.585c.126-.123.178-.303.137-.474s-.168-.31-.336-.362c-.532-.166-1.02-.248-1.49-.248-2.757 0-5 2.243-5 5 0 .323.038.65.118 1.01-.562.463-1.096.862-1.7 1.314-.866.646-1.846 1.377-3.183 2.506C4.95 14.016 4.5 14.99 4.5 16c0 1.93 1.57 3.5 3.5 3.5 1.02 0 1.993-.456 2.662-1.25 1.15-1.347 1.89-2.336 2.544-3.21.442-.59.832-1.11 1.283-1.66.36.082.687.12 1.01.12 2.757 0 5-2.243 5-5 0-.437-.068-.875-.215-1.38zM8 17c-.553 0-1-.447-1-1s.447-1 1-1 1 .447 1 1-.447 1-1 1z\" />\r\n  </svg>\r\n  <h1 class=\"MainTitle\">\r\n    Acceso Denegado\r\n  </h1>\r\n  <p class=\"Main Description\">\r\n\r\n  </p>\r\n\r\n</div>\r\n",
                    styles: ["body,html{position:relative;background:#d4dfe6;min-height:100%;width:100%;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;color:#274c5e}.Container{text-align:center;position:relative}.MainTitle{display:block;font-size:2rem;font-weight:lighter;text-align:center}.MainDescription{max-width:50%;font-size:1.2rem;font-weight:lighter}.MainGraphic{position:relative}.Cog{width:10rem;height:10rem;fill:#6aafe6;-webkit-animation:5s infinite CogAnimation;animation:5s infinite CogAnimation}.Spanner{position:absolute;-webkit-transform:rotate(20deg);transform:rotate(20deg);top:10%;left:20%;width:10rem;height:10rem;fill:#8ec0e4;-webkit-animation:4s infinite SpannerAnimation;animation:4s infinite SpannerAnimation}.Hummingbird{position:absolute;width:3rem;height:3rem;fill:#30a9de;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}@-webkit-keyframes CogAnimation{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes CogAnimation{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes SpannerAnimation{0%{-webkit-transform:translate3d(20px,20px,1px) rotate(0);transform:translate3d(20px,20px,1px) rotate(0)}10%,50%{-webkit-transform:translate3d(-1000px,1000px,1px) rotate(180deg);transform:translate3d(-1000px,1000px,1px) rotate(180deg)}15%,30%{-webkit-transform:translate3d(-1000px,1000px,1px) rotate(360deg);transform:translate3d(-1000px,1000px,1px) rotate(360deg)}20%{-webkit-transform:translate3d(1000px,-1000px,1px) rotate(180deg);transform:translate3d(1000px,-1000px,1px) rotate(180deg)}40%{-webkit-transform:translate3d(1000px,-1000px,1px) rotate(360deg);transform:translate3d(1000px,-1000px,1px) rotate(360deg)}100%{-webkit-transform:translate3d(0,0,0) rotate(360deg);transform:translate3d(0,0,0) rotate(360deg)}}@keyframes SpannerAnimation{0%{-webkit-transform:translate3d(20px,20px,1px) rotate(0);transform:translate3d(20px,20px,1px) rotate(0)}10%,50%{-webkit-transform:translate3d(-1000px,1000px,1px) rotate(180deg);transform:translate3d(-1000px,1000px,1px) rotate(180deg)}15%,30%{-webkit-transform:translate3d(-1000px,1000px,1px) rotate(360deg);transform:translate3d(-1000px,1000px,1px) rotate(360deg)}20%{-webkit-transform:translate3d(1000px,-1000px,1px) rotate(180deg);transform:translate3d(1000px,-1000px,1px) rotate(180deg)}40%{-webkit-transform:translate3d(1000px,-1000px,1px) rotate(360deg);transform:translate3d(1000px,-1000px,1px) rotate(360deg)}100%{-webkit-transform:translate3d(0,0,0) rotate(360deg);transform:translate3d(0,0,0) rotate(360deg)}}"]
                }] }
    ];
    /** @nocollapse */
    AccesoDenegadoComponent.ctorParameters = function () { return []; };
    return AccesoDenegadoComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/page-not-found/page-not-found.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PageNotFoundComponent = /** @class */ (function () {
    function PageNotFoundComponent() {
    }
    /**
     * @return {?}
     */
    PageNotFoundComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        $("body").css("background-color", "#D4DFE6");
    };
    PageNotFoundComponent.decorators = [
        { type: Component, args: [{
                    selector: 'vesta-page-not-found',
                    template: "<div id=\"clouds\">\r\n  <div class=\"cloud x1\"></div>\r\n  <div class=\"cloud x1_5\"></div>\r\n  <div class=\"cloud x2\"></div>\r\n  <div class=\"cloud x3\"></div>\r\n  <div class=\"cloud x4\"></div>\r\n  <div class=\"cloud x5\"></div>\r\n</div>\r\n<div class='c'>\r\n  <div class='_404'>THE PAGE</div>\r\n  <hr>\r\n  <div class='_2'>WAS NOT FOUND</div>\r\n  <a class=''>BACK TO</a>\r\n</div>\r\n",
                    styles: ["body{color:#fff;font-family:'Open Sans',sans-serif;max-height:700px;overflow:hidden}.c{text-align:center;display:block;position:relative;width:80%;margin:100px auto}._404{font-size:4em;position:relative;display:inline-block;z-index:2;letter-spacing:15px}._1{text-align:center;display:block;position:relative;letter-spacing:12px;font-size:4em;line-height:80%}._2{text-align:center;display:block;position:relative;font-size:20px}.text{font-size:70px;text-align:center;position:relative;margin:19px 0 0;z-index:3;width:100%;line-height:1.2em;display:inline-block}.btn{background-color:#fff;position:relative;display:inline-block;width:358px;padding:5px;z-index:5;font-size:25px;margin:0 10px 0 auto;color:#3c9;text-decoration:none}.right{float:right;width:60%}hr{padding:0;border:none;border-top:5px solid #fff;color:#fff;text-align:center;margin:0 auto;width:420px;height:10px;z-index:-10}hr:after{content:\"\\2022\";display:inline-block;position:relative;top:-.75em;font-size:2em;padding:0 .2em;background:#3c9}.cloud{width:350px;height:120px;background:#fff;background:-webkit-gradient(linear,left top,left bottom,to(#fff));background:linear-gradient(to bottom,#fff 100%);background:-o-linear-gradient(top,#fff 100%);border-radius:100px;-webkit-border-radius:100px;-moz-border-radius:100px;position:absolute;margin:120px auto 20px;z-index:-1;-webkit-transition:1s;transition:1s}.cloud:after,.cloud:before{content:'';position:absolute;background:#fff;z-index:-1}.cloud:after{width:100px;height:100px;top:-50px;left:50px;border-radius:100px;-webkit-border-radius:100px;-moz-border-radius:100px}.cloud:before{width:180px;height:180px;top:-90px;right:50px;border-radius:200px;-webkit-border-radius:200px;-moz-border-radius:200px}.x1{top:-50px;left:100px;-webkit-transform:scale(.3);transform:scale(.3);opacity:.9;-webkit-animation:15s linear infinite moveclouds;-moz-animation:15s linear infinite moveclouds;-o-animation:15s linear infinite moveclouds}.x1_5{top:-80px;left:250px;-webkit-transform:scale(.3);transform:scale(.3);-webkit-animation:17s linear infinite moveclouds;-moz-animation:17s linear infinite moveclouds;-o-animation:17s linear infinite moveclouds}.x2{left:250px;top:30px;-webkit-transform:scale(.6);transform:scale(.6);opacity:.6;-webkit-animation:25s linear infinite moveclouds;-moz-animation:25s linear infinite moveclouds;-o-animation:25s linear infinite moveclouds}.x3{left:250px;bottom:-70px;-webkit-transform:scale(.6);transform:scale(.6);opacity:.8;-webkit-animation:25s linear infinite moveclouds;-moz-animation:25s linear infinite moveclouds;-o-animation:25s linear infinite moveclouds}.x4{left:470px;botttom:20px;-webkit-transform:scale(.75);transform:scale(.75);opacity:.75;-webkit-animation:18s linear infinite moveclouds;-moz-animation:18s linear infinite moveclouds;-o-animation:18s linear infinite moveclouds}.x5{left:200px;top:300px;-webkit-transform:scale(.5);transform:scale(.5);opacity:.8;-webkit-animation:20s linear infinite moveclouds;-moz-animation:20s linear infinite moveclouds;-o-animation:20s linear infinite moveclouds}@-webkit-keyframes moveclouds{0%{margin-left:1000px}100%{margin-left:-1000px}}"]
                }] }
    ];
    /** @nocollapse */
    PageNotFoundComponent.ctorParameters = function () { return []; };
    return PageNotFoundComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/http-cancel.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HttpCancelService = /** @class */ (function () {
    function HttpCancelService() {
        this.pendingHTTPRequests$ = new Subject();
    }
    /**
     * @return {?}
     */
    HttpCancelService.prototype.cancelPendingRequests = /**
     * @return {?}
     */
    function () {
        this.pendingHTTPRequests$.next();
    };
    /**
     * @return {?}
     */
    HttpCancelService.prototype.onCancelPendingRequests = /**
     * @return {?}
     */
    function () {
        return this.pendingHTTPRequests$.asObservable();
    };
    HttpCancelService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    HttpCancelService.ctorParameters = function () { return []; };
    /** @nocollapse */ HttpCancelService.ngInjectableDef = ɵɵdefineInjectable({ factory: function HttpCancelService_Factory() { return new HttpCancelService(); }, token: HttpCancelService, providedIn: "root" });
    return HttpCancelService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    HttpCancelService.prototype.pendingHTTPRequests$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/manage-http-interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ManageHttpInterceptor = /** @class */ (function () {
    function ManageHttpInterceptor(router, httpCancelService) {
        var _this = this;
        this.router = router;
        this.httpCancelService = httpCancelService;
        router.events.subscribe((/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (event instanceof ActivationStart) {
                _this.httpCancelService.cancelPendingRequests();
            }
        }));
    }
    /**
     * @template T
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    ManageHttpInterceptor.prototype.intercept = /**
     * @template T
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        return next.handle(req).pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()));
    };
    ManageHttpInterceptor.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ManageHttpInterceptor.ctorParameters = function () { return [
        { type: Router },
        { type: HttpCancelService }
    ]; };
    return ManageHttpInterceptor;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ManageHttpInterceptor.prototype.router;
    /**
     * @type {?}
     * @private
     */
    ManageHttpInterceptor.prototype.httpCancelService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VestaModule = /** @class */ (function () {
    function VestaModule() {
    }
    /**
     * @param {?=} settings
     * @return {?}
     */
    VestaModule.forRoot = /**
     * @param {?=} settings
     * @return {?}
     */
    function (settings) {
        if (settings === void 0) { settings = { isAuthentication: false }; }
        return {
            ngModule: VestaModule,
            providers: [
                { provide: AUTHENTICATION, useValue: settings }
            ]
        };
    };
    VestaModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AccesoDenegadoComponent, PageNotFoundComponent],
                    imports: [
                        CommonModule, HttpClientModule
                    ],
                    providers: [CallHttp, DialogService, HttpCancelService,
                        { provide: HTTP_INTERCEPTORS, useClass: InterceptorSpinnerService, multi: true },
                        { provide: HTTP_INTERCEPTORS, useClass: ManageHttpInterceptor, multi: true }
                    ],
                    exports: [AccesoDenegadoComponent, PageNotFoundComponent]
                },] }
    ];
    return VestaModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/array-extends.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var Enumerable = require("linq");
Array.prototype.Enumerable = (/**
 * @template T
 * @return {?}
 */
function () {
    /** @type {?} */
    var array = this;
    return Enumerable.from(array);
});
var ArrayExtends = /** @class */ (function () {
    function ArrayExtends() {
    }
    return ArrayExtends;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: vesta.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AccesoDenegadoComponent, ArrayExtends, CallHttp, DialogService, InterceptorSpinnerService, Mapper, PageNotFoundComponent, VestaModule, AUTHENTICATION as ɵa, HttpCancelService as ɵb, ManageHttpInterceptor as ɵc };
//# sourceMappingURL=vesta.js.map
